import PropTypes from 'prop-types';

export const SubCategoryType = PropTypes.shape({
  categoryId: PropTypes.string,
  categoryName: PropTypes.string,
  literature: PropTypes.arrayOf(PropTypes.object),
  rank: PropTypes.number
});

export const sectionType = PropTypes.shape({
  data: PropTypes.object,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  view: PropTypes.func.isRequired,
  subCategories: PropTypes.arrayOf(
    PropTypes.oneOfType([SubCategoryType, PropTypes.string])
  )
});
